import type { FaireProductEntity } from "../../entity_types/product";

export const p_bdbjku3mzx: FaireProductEntity = {
  token: "p_bdbjku3mzx",
  type: "product",
  name: "LM-BG-1003 TOTE BAG ZEBRA",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/fb833872cb9bfe03241751e74e9c11090f2ae859c0552d75d6001a263cf1b6a3.png",
  galleryImageUrls: [],
  priceDollars: 15,
  description: "This Zebra tote bag from Girlie Girl Originals offers a bold animal print design suitable for casual use. It provides a standout look that reflects the brand’s fun, fashion-forward style for women.",
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:02:13.200Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
